import { useCallback, useState } from 'react';
import { addIntegrationWebmaster } from '#entities/integration';
import { showError } from '#shared/lib/toast';
import { useWebmasterSiteVerificationStatus } from './useWebmasterSiteVerificationStatus';

export const useWebmasterConnection = () => {
    const status = useWebmasterSiteVerificationStatus();
    const { isSitePublished, refetchAutomaticStatus } = status;
    const [isConnecting, setIsConnecting] = useState(false);

    const connect = useCallback(async () => {
        if (!isSitePublished) {
            showError({ label: 'Сначала подключите домен магазина' });

            return;
        }

        try {
            setIsConnecting(true);
            await addIntegrationWebmaster();
            await refetchAutomaticStatus();
        } catch (error) {
            showError({ label: 'Не удалось подключить Вебмастер' }, error);
        } finally {
            setIsConnecting(false);
        }
    }, [isSitePublished, refetchAutomaticStatus]);

    return { ...status, connect, isConnecting };
};
